import { EtxeApiSlugs, PropertyDto, PropertyId } from '@workspace/data-types';
import { ApiCaller } from '../../../../api-caller.service';
import { ApiConnector } from '../../../../api-connector.abstract-service';
import { PropertiesAgentConnector } from './agent/properties-agent.connector';
import { PropertiesOwnerConnector } from './owner/properties-owner.connector';

export class PropertiesConnector extends ApiConnector<PropertyDto, PropertyDto, PropertyId> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, EtxeApiSlugs.PROPERTIES);
  }

  owner = () => new PropertiesOwnerConnector(this.apiCaller, this.apiPrefix, this.slug);
  agent = () => new PropertiesAgentConnector(this.apiCaller, this.apiPrefix, this.slug);
}
